module.exports = __webpack_public_path__ + "static/mind_map-897cf4034c2b8fa9ce6c442d7487236a.svg";